import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
  ADD_ACTIVITY,
  getApiBaseUrl,
  // EDIT_AHU_FILTER,
} from "../../../Config/Config";
import Swal from "sweetalert2";
import { Select, Spin } from "antd";
const { Option } = Select;

const EditAssetItemLite = ({ formData = {} }) => {
  const [formState, setFormState] = useState({});
  const [filterTypes, setFilterTypes] = useState([]);
  const [locations, setLocationTypes] = useState([]);
  const [locationTypes, setLocationTypeOptions] = useState([]);
  const [ahuOptions, setAhuOptions] = useState([]);
  const [selectedAHU, setSelectedAHU] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [userSessionData, setUserSessionData] = useState(null);
  // Mapping of form state keys to payload keys and display labels

  const fieldMap = {
    Id: { payloadKey: "ID", label: "ID" },
    AHUId: { payloadKey: "AHUId", label: "AHU Unique ID" },
    AssetType: { payloadKey: "AssetType", label: "Filter Type/Category" },
    Manufacturer: { payloadKey: "Manufacturer", label: "Filter Manufacturer" },
    InstalledOn: { payloadKey: "InstalledOn", label: "Date of Installation" },
    Location: { payloadKey: "Location", label: "Block" },
    LocationType: { payloadKey: "LocationType", label: "AHU Type" }, // Added LocationType
    Dimensions: { payloadKey: "Dimensions", label: "Filter Dimensions" },
    MicronRating: { payloadKey: "MicronRating", label: "Micron Rating (µm)" },
    CleaningLimit: { payloadKey: "CleaningLimit", label: "Cleaning Frequency" },
    LastCleaningDate: {
      payloadKey: "LastCleaningDate",
      label: "Last Cleaning Date",
    },
    ValidOperationLife: {
      payloadKey: "ValidOperationLife",
      label: "Valid Operational Life",
    },
    CurrentStatus: { payloadKey: "CurrentStatus", label: "Current Status" },
    AvailabilityStatus: {
      payloadKey: "AvailabilityStatus",
      label: "Availability Status",
    },
    Lable: { payloadKey: "Lable", label: "Code" },
    Specifications: { payloadKey: "Specifications", label: "Specifications" },
    cleaningFreqAllowance: {
      payloadKey: "cleaningFreqAllowance",
      label: "Cleaning Frequency Allowance",
    },
    ROmin: { payloadKey: "ROmin", label: "RO Water Pressure Min" },
    ROmax: { payloadKey: "ROmax", label: "RO Water Pressure Max" },
    AirMin: { payloadKey: "AirMin", label: "Air Pressure Min" },
    AirMax: { payloadKey: "AirMax", label: "Air Pressure Max" },
    cleaningdays: { payloadKey: "cleaningdays", label: "Cleaning Days" },
  };

  useEffect(() => {
    const user = JSON.parse(sessionStorage.getItem("user") || "{}");
    setUserSessionData(user);
  }, []);

  useEffect(() => {
    fetchAHUIds();
    fetchFilterTypes();
    fetchLocationTypes();
    fetchLocationTypeOptions();
  }, []);

  useEffect(() => {
    if (!formData || Object.keys(formData).length === 0) return;

    setFormState({
      Id: Number(formData?.ID ?? ""),
      AHUId: Number(formData?.AHUId ?? ""),
      AssetType: Number(formData?.AssetType ?? ""),
      Manufacturer: String(formData?.Manufacturer ?? ""),
      InstalledOn: formData?.InstalledOn
        ? formData?.InstalledOn.slice(0, 10)
        : "",
      Location: String(formData?.Location ?? ""),
      LocationType: Number(formData?.LocationTypeid ?? ""), // Initialize LocationType
      Dimensions: String(formData?.Dimensions ?? ""),
      MicronRating: String(formData?.MicronRating ?? ""),
      CleaningLimit: String(formData?.CleaningLimit ?? ""),
      LastCleaningDate: formData?.LastCleaningDate
        ? formData?.LastCleaningDate.slice(0, 10)
        : "",
      ValidOperationLife: String(formData?.ValidOperationLife ?? ""),
      CurrentStatus: String(formData?.CurrentStatus ?? ""),
      AvailabilityStatus: String(formData?.AvailabilityStatus ?? ""),
      Lable: String(formData?.Lable ?? ""),
      Specifications: "",
      cleaningFreqAllowance: String(formData?.cleaningFreqAllowance ?? ""),
      ROmin: "",
      ROmax: "",
      AirMin: "",
      AirMax: "",
      cleaningdays: formData?.cleaningdays ?? null,
    });

    // Initialize selectedAHU based on formData
    const ahuMatch = ahuOptions.find(
      (ahu) => Number(ahu.id) === Number(formData?.AHUId)
    );
    setSelectedAHU(
      ahuMatch
        ? { id: ahuMatch.id, code: ahuMatch.code }
        : formData?.AHUcode
        ? { id: "", code: formData?.AHUcode }
        : null
    );
  }, [formData, ahuOptions]);

  const fetchAHUIds = async () => {
    try {
      const res = await fetch(`${getApiBaseUrl()}/api/getAHUIds`);
      if (!res.ok) throw new Error("Failed to fetch AHU IDs");
      const data = await res.json();
      if (data?.Status) {
        setAhuOptions(data.ResultData || []);
      } else {
        setAhuOptions([]);
      }
    } catch (err) {
      console.error("Network error fetching AHU IDs:", err);
      setAhuOptions([]);
    }
  };

  const fetchFilterTypes = async () => {
    try {
      const res = await fetch(`${getApiBaseUrl()}/api/getFilterType`);
      if (!res.ok) throw new Error("Failed to fetch filter types");
      const data = await res.json();
      if (data?.Status) {
        setFilterTypes(data.ResultData || []);
      } else {
        setFilterTypes([]);
      }
    } catch (err) {
      console.error("Network error:", err);
      setFilterTypes([]);
      Swal.fire({
        title: "Error",
        text: "Failed to fetch filter types.",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  const fetchLocationTypes = async () => {
    try {
      const res = await fetch(
        `${getApiBaseUrl()}/api/getprocessnonprocess?locType=0`
      );
      if (!res.ok) throw new Error("Failed to fetch AHU types");
      const data = await res.json();
      if (data?.Status) {
        setLocationTypes(data.ResultData || []);
      } else {
        setLocationTypes([]);
      }
    } catch (err) {
      console.error("Network error:", err);
      setLocationTypes([]);
    }
  };

  const fetchLocationTypeOptions = async () => {
    try {
      const res = await fetch(
        `${getApiBaseUrl()}/api/getprocessnonprocess?locType=1`
      );
      if (!res.ok) throw new Error("Failed to fetch AHU type options");
      const data = await res.json();
      if (data?.Status) {
        setLocationTypeOptions(data.ResultData || []);
      } else {
        setLocationTypeOptions([]);
      }
    } catch (err) {
      console.error("Network error:", err);
      setLocationTypeOptions([]);
    }
  };

  // Function to send notification
  // const sendNotification = async () => {
  //   const notificationPayload = {
  //     Title: "Edit Filter",
  //     Message: "Request raised by Supervisor",
  //     RoleID: 3,
  //   };
  //   try {
  //     const response = await fetch(
  //       `${getApiBaseUrl()}/api/addNotificationsToRole`,
  //       {
  //         method: "POST",
  //         headers: { "Content-Type": "application/json" },
  //         body: JSON.stringify(notificationPayload),
  //       }
  //     );
  //     const result = await response.json();
  //     if (result.Status) {
  //       console.log("Notification sent successfully:", notificationPayload);
  //     } else {
  //       console.warn("Notification API failed:", result);
  //     }
  //   } catch (error) {
  //     console.error("Error sending notification:", error);
  //   }
  // };

  // const handleAHUChange = (values) => {
  //   const inputValue = values[values.length - 1];
  //   const match = ahuOptions.find(
  //     (opt) => opt.code?.toLowerCase() === inputValue?.toLowerCase()
  //   );

  //   if (match) {
  //     setSelectedAHU({ id: match.id, code: match.code });
  //     setFormState((prev) => ({ ...prev, AHUId: String(match.id) }));
  //   } else {
  //     setSelectedAHU({ id: "", code: inputValue });
  //     setFormState((prev) => ({ ...prev, AHUId: "" }));
  //   }
  // };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormState((prev) => ({ ...prev, [name]: String(value) }));
  };

  const handleSelectChange = (name, value) => {
    setFormState((prev) => ({ ...prev, [name]: String(value) }));
  };

  const handleUpdateFilter = async (e) => {
    e.preventDefault();
    if (!userSessionData?.UserID) {
      Swal.fire({
        title: "Error",
        text: "User session not found. Please log in again.",
        icon: "error",
        confirmButtonText: "OK",
      });
      return;
    }

    setIsSubmitting(true);
    const formDataMapped = {
      Id: String(formData?.Id ?? ""),
      AHUId: String(formData?.AHUId ?? ""),
      AssetType: String(formData?.AssetType ?? ""),
      Manufacturer: "",
      InstalledOn: formData?.InstalledOn
        ? formData?.InstalledOn.slice(0, 10)
        : "",
      Location: String(formData?.Location ?? ""),
      LocationType: String(formData?.LocationType ?? ""),
      Dimensions: String(formData?.Dimensions ?? ""),
      MicronRating: String(formData?.MicronRating ?? ""),
      CleaningLimit: String(formData?.CleaningLimit ?? ""),
      LastCleaningDate: formData?.LastCleaningDate
        ? formData?.LastCleaningDate.slice(0, 10)
        : "",
      ValidOperationLife: "",
      CurrentStatus: String(formData?.CurrentStatus ?? ""),
      AvailabilityStatus: "",
      Lable: String(formData?.Lable ?? ""),
      Specifications: "",
      cleaningFreqAllowance: String(formData?.cleaningFreqAllowance ?? ""),
      ROmin: "",
      ROmax: "",
      AirMin: "",
      AirMax: "",
      cleaningdays: String(formData?.cleaningdays ?? 0),
    };

    // Identify changed fields
    const changedFields = Object.keys(fieldMap).filter(
      (key) =>
        String(formState[key] || "") !== String(formDataMapped[key] || "")
    );

    // Map changed fields to their labels
    const changedLabels = changedFields
      .map((key) => fieldMap[key].label)
      .filter(Boolean);

    // Construct payload
    const auditPayload = {
      Id: formData.Id ?? "",
      AHUId: selectedAHU?.id ? selectedAHU.id : "",
      AHUName: selectedAHU?.id ? "" : selectedAHU?.code || "",
      AssetType: formState.AssetType ?? "",
      Manufacturer: "",
      InstalledOn: formState.InstalledOn ?? "",
      Location: formState.Location ?? "",
      Loc: Number(formState.LocationType) ?? "",
      Dimensions: formState.Dimensions ?? "",
      MicronRating: formState.MicronRating ?? "",
      CleaningLimit: "",
      LastCleaningDate: formState.LastCleaningDate ?? "",
      ValidOperationLife: "",
      CurrentStatus: formState.CurrentStatus ?? "",
      AvailabilityStatus: "",
      Lable: formState.Lable ?? "",
      Specifications: "",
      updatedby: userSessionData?.UserID,
      cleaningFreqAllowance: formState.cleaningFreqAllowance ?? "",
      ROmin: "",
      ROmax: "",
      AirMin: "",
      AirMax: "",
      cleaningdays: formState.cleaningdays ?? 0,
    };
    console.log(auditPayload, changedLabels);
    try {
      const response = await fetch(`${getApiBaseUrl()}/api/updateFilterLite`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(auditPayload),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      const isSuccess =
        result.Status && result.ResultData?.[0]?.Status === "Success" ? 1 : 0;

      if (isSuccess) {
        await Swal.fire({
          title: "Success",
          text: "Filter Updated successfully.",
          icon: "success",
          confirmButtonText: "OK",
        });
        window.location.reload();
      } else {
        Swal.fire({
          title: "Update failed",
          text: result?.ResultData?.[0].Message || "Filter Updation failed",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
      await fetch(`${getApiBaseUrl()}${ADD_ACTIVITY}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ActivityType: 1,
          PerformedBy: userSessionData?.UserID,
          PerformedOn: new Date().toISOString().slice(0, 19).replace("T", " "),
          Notes: `Updated Filter ${formState.Lable}`,
          Location: "updateFilter",
          IsSucces: isSuccess,
        }),
      });
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: "Failed to connect to the server.",
        icon: "error",
        confirmButtonText: "OK",
      });

      await fetch(`${getApiBaseUrl()}${ADD_ACTIVITY}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ActivityType: 1,
          PerformedBy: userSessionData?.UserID,
          PerformedOn: new Date().toISOString().slice(0, 19).replace("T", " "),
          Notes: `Updated Filter ${formState.Lable}`,
          Location: "updateFilter",
          IsSucces: 0,
        }),
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <style>
        {`
        @media (max-width: 576px) {
          #offcanvasRightEditFilterAsset {
            width: 90% !important;
          }
        }
        @media (min-width: 577px) and (max-width: 992px) {
          #offcanvasRightEditFilterAsset {
            width: 85% !important;
          }
        }
        @media (min-width: 993px) and (max-width: 1440px) {
          #offcanvasRightEditFilterAsset {
            width: 85% !important;
          }
        }
        @media (min-width: 1441px) {
          #offcanvasRightEditFilterAsset {
            width: 80% !important;
          }
        }
        `}
      </style>
      {isSubmitting && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
          style={{
            zIndex: 1050,
            backdropFilter: "blur(4px)",
            backgroundColor: "rgba(255, 255, 255, 0.2)",
          }}
        >
          <Spin size="large" tip="Processing..." />
        </div>
      )}

      <div
        className="offcanvas offcanvas-end"
        tabIndex={-1}
        id="offcanvasRightEditFilterAsset"
        aria-labelledby="offcanvasRightLabel"
      >
        <form onSubmit={handleUpdateFilter}>
          <div className="offcanvas-header d-flex justify-content-between align-items-center">
            <h4 id="offcanvasRightLabel">Edit Filter</h4>
            <div className="d-flex align-items-center ms-auto">
              <button
                type="submit"
                className="btn btn-sm btn-outline-success me-2"
                title="Save"
                disabled={isSubmitting}
              >
                <i className="fa fa-check fs-4"></i>
              </button>
              <button
                type="button"
                className="btn-close text-reset"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
              ></button>
            </div>
          </div>
          <hr className="m-0" />
          <div className="offcanvas-body">
            <div className="row">
              <div className="col-4 mb-3">
                <label className="form-label">Block</label>
                <span className="text-danger ms-1">*</span>
                <Select
                  showSearch
                  placeholder="Select Block"
                  value={formState.Location || undefined}
                  onChange={(value) => handleSelectChange("Location", value)}
                  className="w-100"
                  required
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children.toLowerCase().includes(input.toLowerCase())
                  }
                >
                  {locations.map((item) => (
                    <Option key={item.BlockId} value={String(item.BlockId)}>
                      {item.BlockName}
                    </Option>
                  ))}
                </Select>
              </div>

              <div className="col-4 mb-3">
                <label className="form-label">AHU ID</label>
                <Select
                  mode="tags"
                  placeholder="Select or type AHU Unique ID"
                  value={selectedAHU?.code ? [selectedAHU.code] : []} // must be array for tags
                  onChange={(values) => {
                    const value = values[values.length - 1];

                    const match = ahuOptions.find((ahu) => ahu.code === value);

                    if (match) {
                      setSelectedAHU({ id: match.id, code: match.code });
                      setFormState((prev) => ({ ...prev, AHUId: match.id }));
                    } else {
                      setSelectedAHU({ id: "", code: value });
                      setFormState((prev) => ({ ...prev, AHUId: "" }));
                    }
                  }}
                  className="w-100"
                >
                  {ahuOptions.map((ahu) => (
                    <Option key={ahu.id} value={ahu.code}>
                      {ahu.code}
                    </Option>
                  ))}
                </Select>
              </div>

              <div className="col-4 mb-3">
                <label className="form-label">AHU Type</label>
                <span className="text-danger ms-1">*</span>
                <Select
                  showSearch
                  placeholder="Select AHU Type"
                  value={Number(formState.LocationType) || undefined}
                  onChange={(value) =>
                    handleSelectChange("LocationType", value)
                  }
                  className="w-100"
                  required
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children.toLowerCase().includes(input.toLowerCase())
                  }
                >
                  {locationTypes.map((item) => (
                    <Option key={item.BlockId} value={Number(item.BlockId)}>
                      {item.BlockName}
                    </Option>
                  ))}
                </Select>
              </div>

              <div className="col-4 mb-3">
                <label className="form-label">Filter ID</label>
                <span className="text-danger ms-1">*</span>
                <input
                  type="text"
                  className="form-control"
                  name="Lable"
                  value={formState.Lable || ""}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="col-4 mb-3">
                <label className="form-label">Filter Size (In Micron)</label>
                <span className="text-danger ms-1">*</span>
                <input
                  type="text"
                  className="form-control"
                  name="MicronRating"
                  value={formState.MicronRating || ""}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="col-4 mb-3">
                <label className="form-label">Filter Type/Category</label>
                <span className="text-danger ms-1">*</span>
                <Select
                  showSearch
                  placeholder="Select Filter Type"
                  value={String(formState.AssetType) || undefined}
                  onChange={(value) => handleSelectChange("AssetType", value)}
                  className="w-100"
                  required
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children.toLowerCase().includes(input.toLowerCase())
                  }
                >
                  {filterTypes.map((item) => (
                    <Option key={item.Id} value={String(item.Id)}>
                      {item.AssetType}
                    </Option>
                  ))}
                </Select>
              </div>

              <div className="col-4 mb-3">
                <label className="form-label">Filter Dimensions</label>
                <span className="text-danger ms-1">*</span>
                <input
                  type="text"
                  className="form-control"
                  name="Dimensions"
                  value={formState.Dimensions || ""}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="col-4 mb-3">
                <label className="form-label">Cleaning Days</label>
                <span className="text-danger ms-1">*</span>
                <div className="input-group">
                  <input
                    type="text"
                    className="form-control"
                    name="cleaningdays"
                    value={formState.cleaningdays || ""}
                    onChange={handleChange}
                    required
                  />
                  <span className="input-group-text">Days</span>
                </div>
              </div>

              <div className="col-4 mb-3">
                <label className="form-label">
                  Cleaning Frequency Allowance
                </label>
                <span className="text-danger ms-1">*</span>
                <div className="input-group">
                  <span className="input-group-text">±</span>
                  <input
                    type="number"
                    name="cleaningFreqAllowance"
                    min={0}
                    className="form-control"
                    placeholder="Enter Frequency"
                    value={formState.cleaningFreqAllowance || ""}
                    onChange={handleChange}
                    onWheel={(e) => e.target.blur()}
                    required
                  />
                  <span className="input-group-text">Days</span>
                </div>
              </div>

              {/* <div className="col-4 mb-3">
                <label className="form-label">Last Cleaning Date</label>
                <span className="text-danger ms-1">*</span>
                <input
                  type="date"
                  className="form-control"
                  name="LastCleaningDate"
                  value={formState.LastCleaningDate || ""}
                  onChange={handleChange}
                  required
                />
              </div> */}
              <div className="col-4 mb-3">
                <label className="form-label">Last Cleaning Date</label>
                <span className="text-danger ms-1">*</span>
                <input
                  type="date"
                  className="form-control"
                  name="LastCleaningDate"
                  value={
                    formState.LastCleaningDate &&
                    new Date(formState.LastCleaningDate).getFullYear() >= 2000
                      ? formState.LastCleaningDate
                      : ""
                  }
                  onChange={handleChange}
                />
              </div>
              <div className="col-4 mb-3">
                <label className="form-label">Current Status</label>
                <span className="text-danger ms-1">*</span>
                <select
                  name="CurrentStatus"
                  className="form-select"
                  value={formState.CurrentStatus || ""}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select</option>
                  <option>Active</option>
                  <option>Cleaning</option>
                  <option>Storage</option>
                </select>
              </div>
            </div>
          </div>
        </form>
      </div>
    </>
  );
};

EditAssetItemLite.propTypes = {
  formData: PropTypes.object,
};

export default EditAssetItemLite;
